import React, { useEffect, useState } from "react";

import { connect } from "react-redux";
import { useStyles } from "../SurveyThankYou/style";
import {
  clearAnswersAndTags,
  clearSurvey,
} from "../../../redux/survey/actions";
import { useIntl } from "react-intl";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import { formatCookieExpirationTime } from "../../helpers/Utils";
import { postData } from "../../helpers/fetch_services";
import {
  isServeFirstBrandingHidden,
  setServeFirstBrandingHidden,
} from "../../../helpers/serveFirstBranding";
import { SERVE_FIRST_LOGO } from "../../../constants/branding";

function SameDaySurvey(props) {
  const intl = useIntl();
  const location = useLocation();
  const { cookieData } = location?.state !== undefined ? location?.state : "";
  const remainingTime = formatCookieExpirationTime(cookieData?.expires);
  // Destructing props
  const { clearAnswersAndTags_, clearSurveyWithoutLogin } = props;
  const backgroundClasses = useStyles();
  const surveyId = cookieData?.survey_id || localStorage.getItem("survey");
  const [hideServeFirst, setHideServeFirst] = useState(
    isServeFirstBrandingHidden,
  );

  const [brandResolved, setBrandResolved] = useState(() => !surveyId);

  useEffect(() => {
    clearAnswersAndTags_();
    clearSurveyWithoutLogin();
  }, []);

  useEffect(() => {
    if (!surveyId) {
      return undefined;
    }

    let cancelled = false;

    const loadBranding = async () => {
      try {
        const result = await postData("api/getBrandDetail", {
          survey_id: surveyId,
        });
        if (cancelled) {
          return;
        }
        if (result?.status === 200) {
          setHideServeFirst(
            setServeFirstBrandingHidden(result?.data?.hideServeFirst),
          );
        }
      } catch (e) {
        // Keep the last known branding state when the lookup fails.
      } finally {
        if (!cancelled) {
          setBrandResolved(true);
        }
      }
    };

    loadBranding();

    return () => {
      cancelled = true;
    };
  }, [surveyId]);
  return (
    <div style={{ minHeight: "100%" }}>
      <section className={`login-wrapper ${backgroundClasses.backgroundImg}`}>
        <div className={backgroundClasses.container}>
          <img
            src="/images/webRating/cil_x-circle.png"
            style={{ width: "12vw" }}
            alt="checkicon"
          />
          {cookieData ? (
            <h2 className={backgroundClasses.thankyouText}>
              {intl.formatMessage(
                {
                  id: "survey-retry-message",
                },
                {
                  value: remainingTime?.value,
                  unit: remainingTime?.unit,
                },
              )}
            </h2>
          ) : (
            <h2 className={backgroundClasses.thankyouText}>
              {intl.formatMessage({
                id: "you-have-already-performed-this-survey",
              })}
            </h2>
          )}
        </div>
        {brandResolved && !hideServeFirst ? (
          <div
            className="logo d-flex align-items-center justify-content-center"
            style={{ position: "absolute", bottom: 9 }}
          >
            <span
              style={{
                marginRight: "15px",
                fontSize: "14px",
                color: "#FFF",
                fontWeight: "bold",
              }}
            >
              {intl.formatMessage({ id: "powered-by" })}
            </span>
            <img
              src={SERVE_FIRST_LOGO}
              alt="powerby"
              style={{ height: "50px" }}
            />
          </div>
        ) : null}
      </section>
    </div>
  );
}

// Map Redux dispatch functions to component props
const mapDispatchToProps = (dispatch) => {
  return {
    clearAnswersAndTags_: () => dispatch(clearAnswersAndTags()),
    clearSurveyWithoutLogin: () => dispatch(clearSurvey()),
  };
};
// Connecting the component to the Redux store
export default connect(() => {}, mapDispatchToProps)(SameDaySurvey);
